
import { Vue, Component, Prop } from "vue-property-decorator";
import { ITableColomns } from "./index.vue";

@Component
export default class FixedTable extends Vue {
  @Prop({ type: Number, default: 37 }) thH;
  @Prop({ type: String, default: "39px" }) rowH;
  @Prop({ type: Boolean, default: true }) showEven; // 是否显示偶数行加深背景

  @Prop({
    default: () => {
      return [];
    },
  })
  columns!: Array<ITableColomns>; // 表格列配置
  @Prop({
    default: () => {
      return [];
    },
  })
  dataSource!: Array<Record<string, any>>; // 表格数据
}
